import * as XLSX from 'xlsx';

export const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
        const fileName = file.name.toLowerCase();
        const fileExtension = file.name.toLowerCase().split('.').pop();
        const isCSV = fileName.endsWith('.csv');

        // Validation format
        if (!['csv', 'xlsx', 'xls', 'ods'].includes(fileExtension)) {
            reject(new Error('Format non supporté. Utilisez Excel (.xlsx) ou OpenDocument (.ods)'));
            return;
        }
        if (isCSV) {
            // Pour les fichiers CSV, essayer UTF-8 d'abord, puis Windows-1252 si nécessaire
            const fileReaderUTF8 = new FileReader();

            fileReaderUTF8.onload = (e) => {
                const textUTF8 = e.target.result;

                // Détecter les problèmes d'encodage Windows-1252 mal lu en UTF-8
                const hasEncodingIssues =
                    /Ã[\u0080-\u00FF]/.test(textUTF8) ||  // Caractères accentués Windows-1252 mal lus
                    /â€™|â€œ|â€�/.test(textUTF8) ||        // Apostrophes et guillemets mal encodés
                    /Ã\s/.test(textUTF8);                 // À, É, etc. mal encodés

                if (hasEncodingIssues) {
                
                    // Réessayer avec Windows-1252
                    const fileReaderWin1252 = new FileReader();

                    fileReaderWin1252.onload = (e2) => {
                        const textWin1252 = e2.target.result;
                  
                        // Détecter le délimiteur (point-virgule ou virgule)
                        const firstLine = textWin1252.split('\n')[0];
                        const delimiter = firstLine.split(';').length > firstLine.split(',').length ? ';' : ',';
                   
                        const wb = XLSX.read(textWin1252, { type: 'string', FS: delimiter });
                        const sheetsData = wb.SheetNames.map((sheetName) => {
                            const ws = wb.Sheets[sheetName];
                            const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
                            return data;
                        });
                        resolve(sheetsData);
                    };

                    fileReaderWin1252.onerror = (error) => {
                        reject(error);
                    };

                    fileReaderWin1252.readAsText(file, 'Windows-1252');
                } else {
                    // UTF-8 fonctionne correctement
               
                    // Détecter le délimiteur (point-virgule ou virgule)
                    const firstLine = textUTF8.split('\n')[0];
                    const delimiter = firstLine.split(';').length > firstLine.split(',').length ? ';' : ',';
                  
                    const wb = XLSX.read(textUTF8, { type: 'string', FS: delimiter });
                    const sheetsData = wb.SheetNames.map((sheetName) => {
                        const ws = wb.Sheets[sheetName];
                        const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
                        return data;
                    });
                    resolve(sheetsData);
                }
            };

            fileReaderUTF8.onerror = (error) => {
                reject(error);
            };

            fileReaderUTF8.readAsText(file, 'UTF-8');
        } else {
            // Pour les fichiers XLSX/XLS, continuer avec ArrayBuffer (pas de problème d'encodage)
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;
                const wb = XLSX.read(bufferArray, { type: 'buffer' });
                const sheetsData = wb.SheetNames.map((sheetName) => {
                    const ws = wb.Sheets[sheetName];
                    const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
                    return data;
                });
                resolve(sheetsData);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        }
    });

    return promise;
}

export const normalizeString = (str) => {
    if (!str) return str;
    return str
        .normalize("NFD") // Décompose les caractères accentués
        .replace(/[\u0300-\u036f]/g, "") // Supprime les accents
        .replace(/[\r\n]/g, " ") // Supprime les retours à la ligne
        .replace(/\s+/g, " ") // Remplace les doubles espaces par un simple
        .trim() // Supprime les espaces inutiles autour de la chaîne
        .toUpperCase(); // Met en majuscules pour uniformiser
};

export const validateHeaders = (headersRow, requiredHeaders) => {
    // Normaliser les en-têtes du fichier Excel
    const headers = Object.keys(headersRow).map(header => normalizeString(header));
    // Normaliser les en-têtes requis
    const requiredHeadersNormalized = requiredHeaders.map(header => normalizeString(header));
 
    // Vérifier si tous les en-têtes requis sont présents
   
    return requiredHeadersNormalized.every(header => headers.includes(header));
};

export const validateClass = (sheet, classeNom, setErrorLoad) => {
    let validate = true;
   
    sheet.forEach(row => {
       
 
        if (''+row.CLASSE !== classeNom) { 
   
            setErrorLoad([`Attention, tous les élèves doivent être de la même classe : ${classeNom} ! Une ou plusieurs feuilles ne sont pas valides.`])
            validate = false;
        }
    });
    return validate;
};

function removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Supprime les diacritiques
}
export   const extractNameAndSurname =(fullName) => {
   
    // Trouver l'index de la première lettre qui n'est pas une majuscule
    let splitIndex = -1;
    for (let i = 0; i < fullName.length; i++) {
        if (fullName[i] !== fullName[i].toUpperCase() && fullName[i] !== ' ') {
            splitIndex = i;
            break;
        }
    }

    if (splitIndex === -1) {
        // Si toutes les lettres sont des majuscules ou espaces, on considère tout comme le nom de famille
        return { nom: fullName.trim(), prenom: "" };
    }

    // Revenir en arrière pour trouver la première majuscule avant splitIndex
    for (let j = splitIndex - 1; j >= 0; j--) {
        if (
            fullName[j] === fullName[j].toUpperCase() && // Vérifier que c'est une majuscule
            fullName[j] !== ' ' && // Vérifier que ce n'est pas un espace
            /^[A-Z]$/.test(fullName[j]) // Vérifier que c'est une lettre de l'alphabet
        ) {
          
            splitIndex = j ; // Inclure la majuscule trouvée dans le prénom
            break;
        }
    }

   // Extraire le nom (tout ce qui est avant l'index trouvé)
   const nom = removeAccents(fullName.slice(0, splitIndex).trim());

   // Extraire le prénom (tout ce qui est après l'index trouvé)
   const prenom = removeAccents(fullName.slice(splitIndex).trim());


   if(!prenom){
  
    return("TanoEd ne détecte pas de prénom dans votre fichier Excel. Avez-vous bien respecter le format? Exemple : DUPONT Jean dans la colonne NOM.")
   }
    return { nom, prenom };
}